module.exports = "<div class=\"c-checkout__steps\">\n    <div ng-repeat=\"(index, step) in $ctrl.checkout.validSteps\" ng-if=\"step !== 'confirmation'\" class=\"c-step{{ $ctrl.checkout.validSteps.indexOf($ctrl.checkout.step) > index ? ' is-active' : '' }}{{ $ctrl.checkout.validSteps.indexOf($ctrl.checkout.step) === index ? ' is-current' : '' }}\" ng-click=\"$ctrl.travel(index, step)\">\n        <div class=\"c-step__indicator\"></div>\n        <div class=\"c-step__text\">\n            <span>{{$ctrl.checkout.displayName(step)}}</span>\n        </div>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/checkout/views/steps.html
// module id = 834
// module chunks = 0